import React from 'react';
import { useTranslation } from '../../i18n';
import { formatPercent } from '../../utils/format';
import { useBackgroundPlan } from '../../utils/backgroundPlan';
import Icon from '../Icon';
import './BackgroundPlanProgress.css';

/** Home screen: the plan that is being made in the background; hidden when there is none. */
const BackgroundPlanProgress: React.FC<{ onOpen?: () => void }> = ({ onOpen }) => {
  const { t, language } = useTranslation();
  const plan = useBackgroundPlan();
  if (!plan) return null;

  const label = plan.statusMessage || t('ai.goalModal.actions.generating');
  return (
    <div className="background-plan" role="status" aria-live="polite">
      <div className="background-plan__head">
        <span className="background-plan__title">
          <Icon name="sparkles" /> {t('ai.goalModal.background.inProgress')}
        </span>
        <span className="background-plan__percent">{formatPercent(plan.progress, language)}</span>
      </div>
      {plan.goalTitle && <div className="background-plan__goal">{plan.goalTitle}</div>}
      <div
        className="background-plan__bar"
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(plan.progress)}
      >
        <span style={{ width: `${plan.progress}%` }} />
      </div>
      <div className="background-plan__foot">
        <span className="background-plan__status">{label}</span>
        {onOpen && (
          <button type="button" className="background-plan__open" onClick={onOpen}>
            {t('ai.goalModal.background.show')}
          </button>
        )}
      </div>
    </div>
  );
};

export default BackgroundPlanProgress;
